import React from 'react';
import { css } from 'emotion';
import ProcessWizardPage from 'components/page/process/wizard/ProcessWizardPage';
import ProcessNameField from 'components/core/fields/ProcessNameField';
import ProcessEmailField from 'components/core/fields/ProcessEmailField';
import ProcessRunLocationsField from 'components/core/fields/ProcessRunLocationsField';
import ProcessDescriptionField from 'components/core/fields/ProcessDescriptionField';

const rowMarginBottom = '20px';
const formElement = css`
            margin-bottom: ${rowMarginBottom};
            .form-label {
                width: 95px;
            }
        `;
const descriptionElement = css`
            ${formElement};
            textarea {
                border: 1px solid #DCDCDC;
                border-radius: 2px;
            }
        `;
const runLocationElement = css`
            ${formElement};
            .editable-component {
                padding: 0 !important;
            }
            .react-select__control {
                border-radius: 2px;
            }
        `;

export default class ProcessInformationPage extends ProcessWizardPage {
    static defaultProps = {
        title: 'Describe Process',
        description: 'Provide some basic information about your process.'
    };

    renderFormWithProcess() {
        return (
            <div className={css`flex: 1`}>
                {/* Name */}
                <ProcessNameField
                    className={formElement}
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    hasWritePermissions={this.props.hasWritePermissions}
                    forceFormDisplay
                    wizardMode
                />

                {/* Description */}
                <ProcessDescriptionField
                    className={descriptionElement}
                    process = {this.props.process}
                    processErrors = {this.props.processErrors}
                    hasWritePermissions={this.props.hasWritePermissions}
                    forceFormDisplay
                />

                {/* Run Locations */}
                <ProcessRunLocationsField
                    className={runLocationElement}
                    process = {this.props.process}
                    processErrors = {this.props.processErrors}
                    hasWritePermissions={this.props.hasWritePermissions}
                    siteFacilities = {this.props.siteFacilities}
                    forceFormDisplay
                />

                {/* Email */}
                <ProcessEmailField
                    className={formElement}
                    process = {this.props.process}
                    processErrors = {this.props.processErrors}
                    hasWritePermissions={this.props.hasWritePermissions}
                    hideWarningLevels
                    forceFormDisplay
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/wizard/ProcessInformationPage.js